// Spend tier definitions from CLASSIFICATION_NORTH_STAR.md (§ Spend tiers).
// The tier determines what re-classification path is even legal — Haiku
// fires only at ≥$10K (Tier M+), Sonnet only at ≥$100K (Tier S+). Tier L
// and T items are allowed to remain unclassified ("free methods only").
//
// We surface the tier in the review UI so an operator can see at a glance
// whether they're looking at a $5 typo or a $5M misclassification, and
// what tools the engine is allowed to throw at it.

export const SPEND_TIERS = [
  {
    key: 'S+',
    label: 'S+',
    description: '> $100K — full cascade, 99% quality bar',
    threshold: 100_000,
    variant: 'critical',
  },
  {
    key: 'S',
    label: 'S',
    description: '$50K – $100K — free + Haiku, 95% bar',
    threshold: 50_000,
    variant: 'high',
  },
  {
    key: 'M',
    label: 'M',
    description: '$10K – $50K — free + Haiku, 95% bar',
    threshold: 10_000,
    variant: 'medium',
  },
  {
    key: 'L',
    label: 'L',
    description: '$1K – $10K — free methods only, 80% bar',
    threshold: 1_000,
    variant: 'low',
  },
  {
    key: 'T',
    label: 'T',
    description: '< $1K — free methods only, unclassified OK',
    threshold: 0,
    variant: 'trivial',
  },
];

export function spendTier(lineTotal) {
  const v = Number(lineTotal) || 0;
  for (const t of SPEND_TIERS) {
    if (v >= t.threshold) return t;
  }
  return SPEND_TIERS[SPEND_TIERS.length - 1];
}

export function formatCurrency(n) {
  const v = Number(n) || 0;
  if (v >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (v >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e3) return `$${(v / 1e3).toFixed(0)}K`;
  return `$${Math.round(v).toLocaleString()}`;
}
